<!-- 我的订单 -->
<template>
<cc-container >
    <cc-main style="overflow:auto;height:100%;" >
    <skeleton v-if="showSkeleton" />
    <cc-container  v-else class="purchase-history"  style="height:100%;">
      <cc-header-nav title="我的订单" :class="transparency?'changebg':''" url="/#/management">
          <template slot="right">
               <div class="search-wrap" @click.stop="openSearch">
               <cc-svg-icon
                 icon-class="search"
                 class-name="search-icon-origin"
               ></cc-svg-icon>
            </div>
        <div  class="ellipsis">
          <van-icon class="ellipsis-icon" name="ellipsis" @click.stop="isShowSmallNav = !isShowSmallNav" />
        </div>
      </template>
      </cc-header-nav>
        <van-tabs class="tabs" v-model="active"  @click="onClick" :swipe-threshold="swipeThreshold" :line-width=17.5 :border="false">
          <van-tab title="全部"></van-tab>
          <van-tab title="待支付"></van-tab>
          <van-tab title="待收货"></van-tab>
          <van-tab title="已完成"></van-tab>
          <van-tab title="已取消"></van-tab>
        </van-tabs>
      <cc-main ref="main">
        <cc-pull-refresh v-model="isLoading" @refresh="onRefresh" class="pull-refresh" :disabled="disabled">
          <div ref="orederScroll" class="order-scroll">
      <van-list
        class="purchase-history-list"
        :class="{'change-block':this.pageArr[this.active].changeBlock}"
        v-model="pageArr[active].loading"
        :finished="pageArr[active].finished"
        :finished-text="pageArr[active].m_finishedText"
        @load="mHandlePullUpLoadMore"
        :immediate-check="m_immediateCheck"
      >
        <not-goods  v-if="loadList.length === 0 && pageArr[active].loading === false"/>
        <!-- <cc-animation-list> -->
          <order-item
           v-for="(item,index) in loadList"
            :key="index"
            :item="item"
            @changeLoad="changeLoad"
            :isReplace='isReplace'
          >
          </order-item>
        <!-- </cc-animation-list> -->
      </van-list>
      </div>
      </cc-pull-refresh>
      </cc-main>
         <cc-small-nav v-model="isShowSmallNav"/>
      <search-overlay
        :show="showSearch"
        @cacel="showSearch=false"
        @transparency="transparency=false"
        :themeColor=true
        :cancelIconColor=true
      >
      </search-overlay>
    </cc-container>
    </cc-main>
     </cc-container>
</template>

<script>
import Vue from 'vue'
import OrderItem from './item.vue'
import { Lazyload, List, Tab, Tabs, Popup, Icon, Toast } from 'vant'
import Skeleton from './skeleton.vue'
import { loadOrderList } from '~fetch/manage-center/order-management'
import NotGoods from '../components/not-goods'
import ListMixin from '@/mixins/list'
import SearchOverlay from './search-overlay'
import { ResultCode } from '~const/ResultCode'
import CountDownMixin from '~mixins/countDown'

Vue.use(List)
  .use(Lazyload)
  .use(Tab)
  .use(Tabs)
  .use(Popup)
  .use(Icon)
  .use(Toast)
export default {
  mixins: [ ListMixin, CountDownMixin ],
  components: {
    OrderItem,
    SearchOverlay,
    NotGoods,
    Skeleton
  },
  name: 'orderManagent',
  data () {
    return {
      isLoading: false, // 下拉刷新开关
      swipeThreshold: 5, // 控制页面tab展示个数
      showPopup: false,
      showSkeleton: true,
      m_loading: false,
      active: 0, // 选中的tab
      state: [
        {
          id: 0,
          text: '全部',
          selected: true
        },
        {
          id: 1,
          text: '待支付',
          selected: false
        },
        {
          id: 4,
          text: '待收货',
          selected: false
        },
        {
          id: 3,
          text: '已完成',
          selected: false
        },
        {
          id: 2,
          text: '已取消',
          selected: false
        }
      ],
      // 存放数据的数组
      list: [
      ],
      pageArr: [{
        page: 1,
        finished: false,
        loading: false,
        m_finishedText: '',
        fristEmpty: false,
        changeBlock: false
      }, {
        page: 1,
        finished: false,
        loading: false,
        m_finishedText: '',
        fristEmpty: false,
        changeBlock: false

      }, {
        page: 1,
        finished: false,
        loading: false,
        m_finishedText: '',
        fristEmpty: false,
        changeBlock: false

      }, {
        page: 1,
        finished: false,
        loading: false,
        m_finishedText: '',
        fristEmpty: false,
        changeBlock: false

      }, {
        page: 1,
        finished: false,
        loading: false,
        m_finishedText: '',
        fristEmpty: false,
        changeBlock: false
      }],
      loadList: [],
      params: {
        search: '',
        state: 0
      },
      showSearch: false, // 是否展示搜索
      isShowSmallNav: false,
      transparency: false, // 是否设置头部透明度为0
      isReplace: '',
      disabled: false
    }
  },
  computed: {},
  created () {
    // 判断是从哪个入口进来的
    if (this.$route.query && this.$route.query.id) {
      this.active = this.$route.query.id
      this.params.state = this.state[this.active].id
      this.mReset()
      const reset = true
      this.loadData(reset)
    }
  },
  mounted () {
  },

  methods: {
    judgeTime (item) {
      return parseInt(+item.over_time - +item.now_time)
    },
    mReset () {
      this.pageArr[this.active].page = 1
      this.pageArr[this.active].loading = false
      this.pageArr[this.active].finished = false
    },
    mHandlePullUpLoadMore () {
      if (!this.pageArr[this.active].finished) {
        if (this.loadData && typeof this.loadData === 'function') {
          this.loadData()
        }
      }
    },
    /**
     *  下拉刷新
     */
    onRefresh () {
      this.mReset()
      this.params.state = this.state[this.active].id
      this.pageArr[this.active].changeBlock = true
      this.loadData(true)
    },
    handleScrollx () {
      if (this.$refs.orederScroll) {
        this.$refs.orederScroll.onscroll = e => {
          if (e.target.scrollTop > 0) {
            this.disabled = true
          } else {
            this.disabled = false
          }
        }
      }
    },
    /**
     *  展开搜索页面
     */
    openSearch () {
      this.transparency = true
      this.showSearch = true
      this.isShowSmallNav = false
    },
    /**
     * @description 采购订单号搜索
     */
    toSearch () {
      this.params.state = 0
      this.search()
    },
    search () {
      this.mReset()
      const reset = true
      this.loadData(reset)
    },
    /**
     * @description 加载数据
     */
    async loadData (reset) {
      // 先清空原有的数据再加载
      this.m_loadText = '正在加载中'
      this.pageArr[this.active].loading = true
      var params = {
        page: this.pageArr[this.active].page,
        limit: this.m_page.limit,
        order_state: this.params.state,
        order_number: this.params.search
      }
      let { data, status } = await loadOrderList(params)
      if (reset) {
        this.list[this.active] = []
      }
      if (status === ResultCode.SUCCESS) {
        this.pageArr[this.active].changeBlock = false
        this.showSkeleton = false
        this.isLoading = false
        Toast.clear()
        if (data.order_data.length === 0) {
          this.pageArr[this.active].fristEmpty = true
        // 全部数据加载完成
          this.pageArr[this.active].m_finishedText = ''
          if (this.list[this.active] && this.list[this.active].length) {
            this.pageArr[this.active].m_finishedText = '--我也是有底线的--'
            this.pageArr[this.active].loading = false
          } else {
            this.list[this.active] = []
            this.loadList = this.list[this.active]
          }
          this.mEnd()
        } else {
        // 倒计时
          this.isReplace = data.is_replace
          data.order_data.forEach(item => {
            item.now_time = data.now_time
            this.$set(item, 'countDown', {
              d: '',
              h: '',
              m: '',
              s: ''
            })
            this.countDown(item)
            if (item.countDown.h === 0 && item.countDown.m === 0 && item.countDown.s === 0) {
              item.countDown = 0
            }
          })
          // 保留数据结构 防止刷新页面出现空白
          if (this.list[this.active]) {
            this.list[this.active] = [...this.list[this.active], ...data.order_data]
          } else {
            this.list[this.active] = [...data.order_data]
          }

          // }
          this.loadList = this.list[this.active]
          if (data.order_data.length < 10) {
            this.pageArr[this.active].m_finishedText = '--我也是有底线的--'
            this.pageArr[this.active].loading = false

            this.pageArr[this.active].finished = true
            // this.m_loadText = '已全部加载完成'
          }
        this.pageArr[this.active].loading = false

        this.pageArr[this.active].page++
        }
        setTimeout(() => {
          this.handleScrollx()
        }, 2000)
      } else {
        this.mEnd()
      }
    },
    mEnd (finishedText = '没有数据了') {
      this.pageArr[this.active].loading = false
      this.pageArr[this.active].finished = true
      this.pageArr[this.active].m_finishedText = this.pageArr[this.active].m_finishedText
    },
    /**
     * @description 选择状态
     */
    onClick (index, title) {
      //
      this.$refs.orederScroll.scrollTop = 0
      this.params.state = this.state[index].id

      if (!this.list[this.active]) {
        if (!this.pageArr[this.active].fristEmpty) {
          this.pageArr[this.active].changeBlock = true
        this.mReset()
        Toast.loading()
        this.loadData()
        return
        }
      }
      this.loadList = this.list[this.active] || []
    },
    /**
     *  刷新页面
     */
    changeLoad () {
      const reset = true
      this.pageArr[this.active].page = 0
      this.loadData(reset)
    }
  },
  activated () {
    if (sessionStorage.getItem('comeOrderDetail')) {
      sessionStorage.removeItem('comeOrderDetail')
      this.changeLoad()
    }
    if (sessionStorage.getItem('scrollOrderList') && this.$refs.orederScroll) {
      this.$refs.orederScroll.scrollTop = sessionStorage.getItem('scrollOrderList')
    }
  },
  deactivated () {
    sessionStorage.setItem('scrollOrderList', this.$refs.orederScroll.scrollTop)
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'orderer-details' || to.name === 'orderer') {
      !this.$keeplive.includes('orderManagent') && this.$keeplive.push('orderManagent')
    } else if (to.name === 'management') {
      this.$keeplive.forEach((item, i) => {
        if (item === 'orderManagent') {
          this.$keeplive.splice(i, 1)
        }
      })
    }
    next()
  }
}

</script>
<style lang='scss' scoped>
@import '~styles/index.scss';
  /deep/{
    .search-overlay .search-header{
     background: linear-gradient(to right,var(--APP_theme_color) , var(--APP_theme_color_colorOpacity5));
  }
  .left-arrow{
    color: #fff;
  }
  }
.changebg{
  opacity: 0;
}
 .search-icon-origin {
    position: relative;
     left: -5px;
     color: #fff;
   }
   .ellipsis-icon{
     margin-right: 5px;
   }
.search-box{
 height: 30px;
 display: flex;
 flex-direction: row;
 align-items: center;
//  position:absolute;
.input-search{
  border: none !important;
}
  input{
  width: 280px;
  height: 29px;
  border-radius: 15px;
 background: rgba(255,255,255,.5);
  border: none;
  text-indent: 8px;
  font-size: 12px;
  color: #fff;
&::-webkit-input-placeholder { /* WebKit browsers 适配谷歌 */
    color: #fff;
}
&:-moz-placeholder { /* Mozilla Firefox 4 to 18 适配火狐 */
    color: #fff;
}
&::-moz-placeholder { /* Mozilla Firefox 19+ 适配火狐 */
    color: #fff;
}
&:-ms-input-placeholder { /* Internet Explorer 10+  适配ie*/
    color: #fff;
}
  }
  .search-icon {
    position: relative;
     left: 25px;
     color: #fff;
   }
}
.navbar{
  width: 20px;
}
.ellipsis{
  width: 100%;
  height: 100%;
  @include center();
  &-icon{
    transform: rotate(90deg);
  }
}
.tabs{
  height: 0!important;
  /deep/{
    .van-tab--active{
      color:  var(--APP_theme_color)!important;
    }
    .van-tabs__line{
      bottom: 22px;
      background-color: var(--APP_theme_color)!important;
    }
    .van-tabs__nav{
      background-color: #f5f5f5;
    }
    .van-hairline--top-bottom:after{
      border-width: 0;
    }
    .van-tab{
      line-height: 47px;
    }
  }
}
.change-block{
  /deep/.van-list__loading{
    display:none;
  }
}
  .order-scroll{
    height: calc(100vh - 89px);
    overflow: scroll;
  }
</style>
